import { jsx } from 'theme-ui';
import React from 'react';
import { Link } from 'gatsby';
import { Container } from './organisms';
import { Flex, Box, Text, Link as ExternalLink } from '@theme-ui/components';
import { FaFacebookF, FaTwitter, FaLinkedinIn } from 'react-icons/fa';

const FooterText = `greytHR is India’s leading Cloud Payroll and HR Software. It enables 20,000+ organizations to manage their Payroll and HR process efficiently. Backed with 25 years of experience, greytHR enables processing of 20 Lakh+ employee records on a daily basis.`;
const SMLinks = ({ path, children }) => {
  const sx = {
    borderRadius: '50%',
    width: 40,
    p: 1,
    textAlign: 'center',
    '&:hover': {
      backgroundColor: 'gray',
    },
  };
  return (
    <Box sx={sx}>
      <ExternalLink href={path} target="_blank">
        {children}
      </ExternalLink>
    </Box>
  );
};

const FooterV2 = () => (
  <Box sx={{ bg: '#383939' }}>
    <Container sx={{ maxWidth: ['95%', '95%', '95%', '70%']}}>
      <Flex sx={subContainer}>
        <Box sx={{ fontWeight: 'bold' }}>ABOUT greytHR</Box>
        <Box sx={{ my: 2 }}>{FooterText}</Box>
        <Flex sx={bottomBand}>
          <Text mb={[4, 0]}>Copyright © 2023 Greytip Software Pvt. Ltd.</Text>
          <Text>
            <Link to="/privacy-policy/">Privacy Policy</Link> |{' '}
            <Link to="/terms-service/">Terms of Service</Link>
          </Text>
          <Flex
            sx={{
              width: 88,
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            <SMLinks path="https://www.facebook.com/greytip">
              <FaFacebookF color="#DDDDDD" />
            </SMLinks>
            <SMLinks path="https://www.linkedin.com/company/greytip-software-pvt-ltd-">
              <FaLinkedinIn color="#DDDDDD" />
            </SMLinks>
            <SMLinks path="https://twitter.com/greythr2">
              <FaTwitter color="#DDDDDD" />
            </SMLinks>
          </Flex>
        </Flex>
      </Flex>
    </Container>
  </Box>
);

const subContainer = {
  color: 'white',
  pt: 5,
  pb: 4,
  justifyContent: 'center',
  flexDirection: 'column',
  fontSize: '0.875rem',
  lineHeight: '20.3px',
  a: {
    color: '#DDDDDD',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
};

const bottomBand = {
  justifyContent: 'space-between',
  color: '#DDDDDD',
  alignItems: 'center',
  flexDirection: ['column', 'row'],
  alignItems: ['flex-start', 'center'],
  height: ['120px', 'auto'],
  mt: 4,
};

export default FooterV2;